// API接口定义
import request from '@/utils/request'

// 示例API接口
export const api = {
  // 获取文章详情
  getArticleDetail: (type: string, id?: string | number): Promise<any> => {
    const safeType = encodeURIComponent(type)
    if (id === undefined || id === null || id === '') {
      return request.get(`/article/${safeType}`)
    }
    const safeId = encodeURIComponent(String(id))
    return request.get(`/article/${safeType}/${safeId}`)
  },
  
  // 获取APP配置（下载链接）
  getAppConfig: (platform: 'android' | 'ios'): Promise<any> => {
    return request.get('/app_config', {
      headers: {
        'Platform': platform
      }
    })
  },
}